/**
 * Utility function to check if an image URL is an SVG file
 * @param url - The image URL to check
 * @returns true if the URL appears to be an SVG file
 */
export function isSvgImage(url: string): boolean {
  if (!url) return false;

  const lowerUrl = url.toLowerCase();
  return lowerUrl.includes('.svg') || lowerUrl.endsWith('.svg');
}

/**
 * Utility function to check if any image URL in an array is an SVG file
 * @param urls - Array of image URLs to check
 * @returns true if any of the URLs appear to be SVG files
 */
export function hasSvgImage(urls: string[]): boolean {
  return urls.some((url) => isSvgImage(url));
}
